export default __webpack_public_path__ + "static/nitrd-0308c368040d9887876b8d4b8588cb7f.png";